var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "智能销售账号换绑",
        width: "700px",
        loading: _vm.loading,
        height: "auto",
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "editRemarks overflowOuto",
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "margin-top": "12px" },
              attrs: {
                "label-width": "auto",
                model: _vm.form,
                size: "small",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "换绑方式：", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "168px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      on: { change: _vm.onhandleTypeChang },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    },
                    [_c("el-option", { attrs: { label: "手机号", value: 1 } })],
                    1
                  ),
                ],
                1
              ),
              _vm.form.type === 1
                ? _c("el-form-item", { attrs: { label: "账户手机号：" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.phone))]),
                        _c("span", [
                          _vm._v(
                            "请确保当前手机号码对应的企业微信已经完成认证"
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "thirdAccountsListContent" },
                      [
                        _c(
                          "el-image",
                          {
                            staticClass: "imgAvater",
                            attrs: { src: _vm.weChat.bizWechatAvatar },
                          },
                          [
                            _c("template", { slot: "error" }, [
                              _c("img", {
                                staticStyle: { width: "58px", height: "58px" },
                                attrs: {
                                  src: require("@/assets/image/imgloadError.png"),
                                  alt: "",
                                },
                              }),
                            ]),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.weChat.bizWechatName)),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.weChat.bizWechatAlias)),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.form.type === 2
                ? _c("el-form-item", { attrs: { label: "企微二维码绑定：" } }, [
                    _c("div", { staticClass: "wecomApplyTips" }, [
                      _vm._v(" 请使用 "),
                      _c("span", { staticStyle: { color: "#2c3242" } }, [
                        _vm._v("【企微】"),
                      ]),
                      _vm._v(" 移动端扫描二维码 "),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        staticClass: "new-scan-qrcode-container",
                      },
                      [
                        _c("div", {
                          staticStyle: { width: "182px", height: "182px" },
                          attrs: { id: "wecomApply_wecom_login_container" },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }